import { render, staticRenderFns } from "./providerIdDocumentMgrModal.vue?vue&type=template&id=74a50895&scoped=true&"
import script from "./providerIdDocumentMgrModal.vue?vue&type=script&lang=js&"
export * from "./providerIdDocumentMgrModal.vue?vue&type=script&lang=js&"
import style0 from "./providerIdDocumentMgrModal.vue?vue&type=style&index=0&id=74a50895&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a50895",
  null
  
)

export default component.exports